import { PickersCalendarHeaderProps } from '@mui/x-date-pickers/PickersCalendarHeader';
import { addMonths, format, isAfter, isBefore, startOfMonth, subMonths } from 'date-fns';
import { FC } from 'react';

import { IconButton } from '../Button';
import ChevronLeftIcon from './assets/chevron-left.svg';
import ChevronRightIcon from './assets/chevron-right.svg';
import { StyledHeader, StyledMonthLabel } from './DatePickerNavHeader.styled';

export interface DatePickerNavHeaderProps extends PickersCalendarHeaderProps {
  onLabelClick: () => void;
}

const DatePickerNavHeader: FC<DatePickerNavHeaderProps> = ({
  currentMonth,
  onMonthChange,
  disabled,
  minDate,
  maxDate,
  disablePast,
  disableFuture,
  onLabelClick,
}) => {
  const today = new Date();

  const effectiveMinDate = disablePast ? today : minDate;
  const effectiveMaxDate = disableFuture ? today : maxDate;

  const isPrevDisabled =
    disabled ||
    (effectiveMinDate != null &&
      !isAfter(startOfMonth(currentMonth), startOfMonth(effectiveMinDate)));

  const isNextDisabled =
    disabled ||
    (effectiveMaxDate != null &&
      !isBefore(startOfMonth(currentMonth), startOfMonth(effectiveMaxDate)));

  const handlePrev = () => {
    if (!isPrevDisabled) onMonthChange(subMonths(currentMonth, 1));
  };

  const handleNext = () => {
    if (!isNextDisabled) onMonthChange(addMonths(currentMonth, 1));
  };

  return (
    <StyledHeader>
      <IconButton
        color="tertiary"
        variant="outline"
        size="xs"
        onClick={handlePrev}
        disabled={isPrevDisabled}
        aria-label="Previous month"
      >
        <ChevronLeftIcon />
      </IconButton>

      <StyledMonthLabel type="button" onClick={onLabelClick} disabled={disabled}>
        {format(currentMonth, 'MMMM yyyy')}
      </StyledMonthLabel>

      <IconButton
        color="tertiary"
        variant="outline"
        size="xs"
        onClick={handleNext}
        disabled={isNextDisabled}
        aria-label="Next month"
      >
        <ChevronRightIcon />
      </IconButton>
    </StyledHeader>
  );
};

export default DatePickerNavHeader;
